import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center gap-4" }
const _hoisted_2 = { class: "drag-handle cursor-pointer w-6 h-10 flex justify-center items-center" }
const _hoisted_3 = {
  class: "tooltip",
  "data-tip": "Type of color interpolation"
}
const _hoisted_4 = {
  class: "tooltip",
  "data-tip": "Duration in milliseconds (0 means forever)"
}
const _hoisted_5 = { class: "join" }
const _hoisted_6 = ["onClick"]

import { ref } from "vue";
import { Container, Draggable, DropResult } from "vue-dndrop";
import { Transition } from "@/keyboard";
import { INTERPOLATION } from "@/keyboard/leds";
import IntegerInput from "@/components/utils/IntegerInput.vue";
import ColorInput from "@/components/utils/ColorInput.vue";
import ListSelect from "@/components/utils/ListSelect.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TransitionsEdit',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dragOngoing = ref(false);

const remove = (id: number) => {
  if (id < 0 || id >= props.modelValue.length) return;
  const tnew = props.modelValue
    .slice(0, id)
    .concat(props.modelValue.slice(id + 1));
  emit("update:modelValue", tnew);
};

const add = () => {
  const added: Transition = {
    color: [255, 255, 255],
    duration: 1000,
    interpolation: "Linear",
  };
  emit("update:modelValue", [...props.modelValue, added]);
};

const drop = (result: DropResult) => {
  const from = result.removedIndex;
  const to = result.addedIndex;
  if (from == null || to == null) return;

  const list = [...props.modelValue];
  if (from < 0 || from > list.length - 1) return; // out of range
  if (to < 0 || to > list.length - 1) return; // out of range

  list.splice(to, 0, list.splice(from, 1)[0]);

  emit("update:modelValue", list);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_unref(Container), {
    class: "flex flex-col justify-center items-center gap-2",
    dragHandleSelector: ".drag-handle",
    onDrop: drop,
    onDragStart: _cache[1] || (_cache[1] = ($event: any) => (dragOngoing.value = true)),
    onDragEnd: _cache[2] || (_cache[2] = ($event: any) => (dragOngoing.value = false))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (trans, id) => {
        return (_openBlock(), _createBlock(_unref(Draggable), { key: id }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_Icon, { icon: "ic:baseline-drag-indicator" })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(ListSelect, {
                  class: "w-[14ch]",
                  clearable: false,
                  options: _unref(INTERPOLATION),
                  modelValue: trans.interpolation,
                  "onUpdate:modelValue": ($event: any) => ((trans.interpolation) = $event)
                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(IntegerInput, {
                    class: "w-[9ch] input-sm join-item h-10",
                    min: 0,
                    max: 65535,
                    modelValue: trans.duration,
                    "onUpdate:modelValue": ($event: any) => ((trans.duration) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "join-item btn-input-unit btn-input-unit-sm !h-10" }, "ms", -1))
                ])
              ]),
              _createVNode(ColorInput, {
                modelValue: trans.color,
                "onUpdate:modelValue": ($event: any) => ((trans.color) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-circle btn-sm btn-outline h-9 w-9 text-neutral bg-base-100 hover:border-neutral hover:bg-neutral", 
            _ctx.modelValue.length <= 1 ? 'pointer-events-none opacity-40' : ''
          ]),
                onClick: () => remove(id)
              }, [
                _createVNode(_component_Icon, {
                  icon: "ic:baseline-delete",
                  onMouseout: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                })
              ], 10, _hoisted_6)
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      (_ctx.modelValue.length < 254)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-circle btn-sm btn-outline h-9 w-9 text-neutral hover:border-neutral hover:bg-neutral",
            onClick: add
          }, [
            _createVNode(_component_Icon, {
              icon: "ic:baseline-add",
              class: "hover:fill-neutral-content"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})